
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[category]/[slug]",
      function () {
        return require("private-next-pages/guides/[category]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/[category]/[slug]"])
      });
    }
  